import { API_BASE_URL, CHATBOT_URL } from 'config';
import { USER_TOKEN } from 'helpers/storage';
import { useEffect } from 'react';

const ChatbotModal = () => {
  const token = USER_TOKEN.get()?.replace('Bearer ', '').trim();
  const backendUrl = API_BASE_URL;

  useEffect(() => {
    if (!token) return;

    // 1️⃣ Set global config FIRST
    window.ChatbotConfig = {
      chatbotUrl: CHATBOT_URL,
      token,
      origin: backendUrl,
    };


    // 2️⃣ Prevent duplicate script load
    if (document.getElementById('mindchamps-chatbot')) return;

    // 3️⃣ Inject script
    const script = document.createElement('script');
    script.id = 'mindchamps-chatbot';
    script.src = `${CHATBOT_URL}/chatbot-widget.js`;
    script.async = true;

    document.body.appendChild(script);

    // 4️⃣ Cleanup (optional but recommended)
    return () => {
      script.remove();
      delete window.ChatbotConfig;
    };
  }, [token, backendUrl]);

  return null; // widget handles its own UI
};

export default ChatbotModal;
